<template>
    <v-card
        v-if="show"
        class="model-name-suggestion"
        transition="scale-transition"
        dark
        :style="position"
    >
        <v-card-title class="title">
            {{$t('instance.data_model.name_suggestion.name_card')}}
        </v-card-title>
        <v-card-text style="padding-top: 0;">
            <v-alert
                color="error"
                outlined
            >
                {{ msg }}
                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <i v-on="on" aria-hidden="true" class="v-icon material-icons theme--dark" style="font-size: 16px; color: rgb(158, 158, 158); caret-color: rgb(158, 158, 158);">info</i>
                    </template>
                    <span>PascalCase</span>
                </v-tooltip>
            </v-alert>
            {{$t('instance.data_model.name_suggestion.suggestion_text')}}
            <div class="content-container">
                <v-text-field v-model="caseSuggestion" disabled></v-text-field>
                <div>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                fab
                                dark
                                small
                                color="grey darken-3"
                                @click="accept"
                            >
                                <v-icon dark>done</v-icon>
                            </v-btn>
                        </template>
                        <span>
                            {{$t('instance.data_model.name_suggestion.apply_text')}}
                        </span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                fab
                                dark
                                small
                                color="grey darken-3"
                                @click="decline"
                            >
                                <v-icon dark>close</v-icon>
                            </v-btn>
                        </template>
                        <span>
                            {{$t('instance.data_model.name_suggestion.close_text')}}
                        </span>
                    </v-tooltip>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>

export default {

    components: {

    },

    props: {
    },

    data (){
        return {
            show: false,
            caseSuggestion: '',
            msg: '',
            position: '',
        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
        open (data, position){
            this.caseSuggestion = data.suggestion;
            this.msg = data.error;
            this.show = true;
            this.position = position;
        },
        close (){
            this.show = false;
        },
        accept (){
            this.$emit('suggestion-accepted', this.caseSuggestion);
            this.show = false;
        },
        decline (){
            this.show = false;

        },
    },
};
</script>

<style lang="scss">

    .model-name-suggestion{
        position: absolute;
        z-index:10;
        width: 300px;
        padding: 5px 10px 0 10px;
        right: -100px;
        bottom: -373px;
        // top: 80px;

        .tooltip-icone-suggestion{
            color :#FFFFFF;
            border-radius: 10px;
            text-align: center;
            font-size: 12px;
            cursor: help;
        }

            .tooltip{
                padding: 2px 5px;
                border-radius: 10px;
                position: relative;
                pointer-events: none;
                opacity: 0;
                background-color: #565151;
                color: #ffffff;
                text-align: center;
                span{
                    color: #ff5252;
                    font-weight: bold;
                }
                a{
                    color: #ffffff;
                    text-decoration: none;
                }
            }

        .tooltip-icone-suggestion:hover .tooltip{
            opacity: 1;
            pointer-events: auto;
            color: #ffffff;
        }


        .tooltip:before{
            position: absolute;
            content: "";
            cursor: help;
        }

        .content-container{
            display: flex;
            justify-content: space-between;
            align-items: center;
            button{
                width: 20px;
                height: 20px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/Instance/DataModel/name-suggestion.vue